import React, { ComponentPropsWithRef } from "react";

type Variant = "primary" | "outline" | "ghost" | "danger";

const BASE =
  "inline-flex items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-medium " +
  "transition-colors duration-150 disabled:pointer-events-none disabled:opacity-40";

// On a light canvas the hover state has to darken rather than lighten, so
// `primary` hovers to brand-strong — the reverse of the dark reference.
const VARIANTS: Record<Variant, string> = {
  primary: "bg-brand text-white hover:bg-brand-strong shadow-lg shadow-brand/20",
  outline:
    "border border-hairline bg-surface text-zinc-700 hover:bg-elevated hover:text-zinc-900",
  ghost: "text-zinc-600 hover:bg-elevated hover:text-zinc-900",
  danger: "text-red-600 hover:bg-red-500/10",
};

type ButtonProps = ComponentPropsWithRef<"button"> & { variant?: Variant };

export function Button({
  variant = "ghost",
  className = "",
  type = "button",
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      className={`${BASE} ${VARIANTS[variant]} ${className}`}
      {...props}
    />
  );
}
